import { Currency } from '@/core/currency/interfaces';

const OMR: Currency = {
    name: 'Omani Rial',
    demonym: 'Omani',
    majorSingle: 'Rial',
    majorPlural: 'Rials',
    codeNumeric: '512',
    symbol: 'OR',
    symbolNative: 'ر.ع.',
    minorSingle: 'Baisa',
    minorPlural: 'Baisa',
    ISOdigits: 3,
    decimals: 3,
    numToBasic: 1000,
    code: 'OMR',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default OMR;
